import { OfflineDocumentGroup } from '@luzula/luzula-lib';

const D = 'assets/SEA/SEA Teil D 02.2026';

export const SEA_DOCUMENT_GROUPS: OfflineDocumentGroup[] = [
	{
		label: 'SEA-Dokumente',
		urls: [
			// Hauptteile
			'assets/SEA/SEA Teil A 02-2025.pdf',
			'assets/SEA/SEA 95 Teil B, Druckvorlage_Stand_20_3_25.pdf',
			'assets/SEA/SEA Teil C Zuordnungskatalog 03-25.pdf',
			'assets/SEA/SEA-D Bodenformen-Katalog_Stand 02.26.pdf',
			// Teil D Einführung
			`${D}/SEA-D Bodenformen-Katalog Einführung_02.26.pdf`,
			`${D}/04Datenverzeichnis für Bodenformen(S.31-39)_02-26.pdf`,
			`${D}/04SeaDFeinbodenfverz_(S.40-80)_02-26.pdf`,
			// Anhydromorphe Böden
			`${D}/Anhydromorphe Böden_02.26.pdf`,
			`${D}/05Anhydro1Sandböden_02.26.pdf`,
			`${D}/05Anhydro2Bändersandböden_02-26.pdf`,
			`${D}/05Anhydro3Lehmsandböden_02_26.pdf`,
			`${D}/05Anhydro4Staubsandböden_02-26.pdf`,
			`${D}/05Anhydro5Bänderstaubsandböden_02-26.pdf`,
			`${D}/05Anhydro6Grandböden_02-26.pdf`,
			`${D}/05Anhydro7Bändergrandböden_02-26.pdf`,
			`${D}/05Anhydro8Skelettböden_02-26.pdf`,
			`${D}/05Anhydro9Kalkböden_02-26.pdf`,
			`${D}/05Anhydro10Lehmböden_02-26.pdf`,
			`${D}/05Anhydro11Tonböden_02-26.pdf`,
			// Halbgley-Böden
			`${D}/Halbgleye_02-26.pdf`,
			`${D}/06Halbgley1Sandböden_02-26.pdf`,
			`${D}/06Halbgley2Skelettböden_02-26.pdf`,
			`${D}/06Halbgley3Lehmböden_02-26.pdf`,
			`${D}/06Halbgley4DeckTieflehmböden_02-26.pdf`,
			`${D}/06Halbgley5Tonböden_02-26.pdf`,
			// Graugley-Böden
			`${D}/Graugleye_02-26.pdf`,
			`${D}/07Graugley1Sandböden_02-26.pdf`,
			`${D}/07Graugley2Kalkböden_02-26.pdf`,
			`${D}/07Graugley3Lehmböden(S374-392)_02-25.pdf`,
			`${D}/07Graugley4Tonböden_02-26.pdf`,
			// Humusgley-Böden
			`${D}/Humusgleye_02-26.pdf`,
			`${D}/08Humusgley1Sandböden-02-26.pdf`,
			`${D}/08Humusgley2Skelettböden_02-26.pdf`,
			`${D}/08Humusgley3Kalkböden_02-26.pdf`,
			`${D}/08Humusgley4Lehmböden_02-26.pdf`,
			`${D}/08Humusgley5Tonböden_02-26.pdf`,
			// Weitere
			`${D}/09Moore(S461)_neu_01-25.pdf`,
			`${D}/10 Komplexstandorte_02-26.pdf`,
			// Metadaten (Titel, Inhalt, Vorspann)
			`${D}/01SeaDTitel_Stand_02.26.pdf`,
			`${D}/02SeaDInhalt(S.3-4)_02.26.pdf`,
			`${D}/03SeaDVorsp_Stand_02.26_S5-30.pdf`,
		]
	}
];
